import {CALL_API} from "../../helpers/middleware";

const KleidungActions = {

    LOAD_KLEIDUNG_REQUEST : 'LOAD_KLEIDUNG_REQUEST',
    LOAD_KLEIDUNG_SUCCESS : 'LOAD_KLEIDUNG_SUCCESS',
    LOAD_KLEIDUNG_ERROR : 'LOAD_KLEIDUNG_ERROR',

    SHOW_KLEIDUNG_MODAL: 'SHOW_KLEIDUNG_MODAL',


    SAVE_KLEIDUNG_REQUEST: 'SAVE_KLEIDUNG_REQUEST',
    SAVE_KLEIDUNG_SUCCESS: 'SAVE_KLEIDUNG_SUCCESS',
    SAVE_KLEIDUNG_ERROR: 'SAVE_KLEIDUNG_ERROR',

};

export default KleidungActions;


export function LoadArbeitskleidungen() {
    return {
        [CALL_API]: {
            reqType: 'GET',
            endpoint: 'clothes',
            types: [KleidungActions.LOAD_KLEIDUNG_REQUEST, KleidungActions.LOAD_KLEIDUNG_SUCCESS, KleidungActions.LOAD_KLEIDUNG_ERROR]
        }
    };
}

export function SaveArbeitskleidungen(values, GroupID) {
    return {
        [CALL_API]: {
            reqType: 'PUT',
            endpoint: 'clothes/'+GroupID,
            postData: {Kleidung: values.Kleidung},
            types: [KleidungActions.SAVE_KLEIDUNG_REQUEST, KleidungActions.SAVE_KLEIDUNG_SUCCESS, KleidungActions.SAVE_KLEIDUNG_ERROR]
        }
    };
}

export function showArbeitskleidungModal(show, GroupID) {
    return {
        type: KleidungActions.SHOW_KLEIDUNG_MODAL,
        show,
        GroupID
    };
}


/*
export function saveHausverboteDetail(values, BanID) {
    let url = "ban";
    let type = "POST";
    if(BanID) {
        url += "/"+BanID;
        type = "PUT";
    } else {
        url += "/new";
    }

    return {
        [CALL_API]: {
            reqType: type,
            endpoint: url,
            postData: values,
            types: [HausverboteActions.SAVE_HAUSVERBOTE_REQUEST, HausverboteActions.SAVE_HAUSVERBOTE_SUCCESS, HausverboteActions.SAVE_HAUSVERBOTE_ERROR]
        }
    };
}

export function LoadHausverboteDetail(BanID) {
    return {
        [CALL_API]: {
            reqType: 'GET',
            endpoint: 'ban/'+BanID,
            types: [HausverboteActions.LOAD_HAUSVERBOTE_DETAIL_REQUEST, HausverboteActions.LOAD_HAUSVERBOTE_DETAIL_SUCCESS, HausverboteActions.LOAD_HAUSVERBOTE_DETAIL_ERROR]
        }
    };
}

export function deleteHausverbot(BanID) {
    return {
        [CALL_API]: {
            reqType: 'DELETE',
            endpoint: 'ban/'+BanID,
            types: [HausverboteActions.DELETE_HAUSVERBOTE_REQUEST, HausverboteActions.DELETE_HAUSVERBOTE_SUCCESS, HausverboteActions.DELETE_HAUSVERBOTE_ERROR]
        }
    };
}




export function setHausverboteTablePage(pager) {
    return {
        type: HausverboteActions.SET_HAUSVERBOTE_TABLE_PAGE,
        pager
    };
};

export function setHausverboteTableInfo(infos) {
    return {
        type: HausverboteActions.SET_HAUSVERBOTE_TABLE_INFO,
        infos
    };
};

export function setSearchText(search) {
    return {
        type: HausverboteActions.SET_SEARCH_TEXT,
        search
    };
};
*/
 




